module.exports = __webpack_public_path__ + "img/APIConnectivity.ecf83a2e.png";